import React from 'react'
import { SVGProps } from './types'

export const Profile: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-circle-user-round-icon lucide-circle-user-round"
      onClick={onClick && (() => onClick())}
    >
      <path d="M18 20a6 6 0 0 0-12 0" />
      <circle cx={12} cy={10} r={4} />
      <circle cx={12} cy={12} r={10} />
    </svg>
  )
}
